import React from "react"
import styled from "@emotion/styled"
import { Box } from "theme-ui"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const TeamBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 300px;
    min-height: 300px;
    margin: 1rem 0;
    padding: 1rem;
    box-shadow: rgba(0, 0, 0, 0.24) 4px 5px 8px;
    position: relative;

    & .image-wrapper {
        display: inline-block;
        position: relative;
        width: 250px;
        height: 250px;
        overflow: hidden;
        margin-top: 2rem;
        align-self: end;

        & img {
            width: auto;
            height: 100%;
            transition: transform 0.5s;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[6]}) {
            width: 175px;
            height: 175px;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[5]}) {
            width: 150px;
            height: 150px;
        }
    }
    & span {
        margin-right: 1rem;
        font-weight: 500;
        color: ${(props) => props.theme.colors.background};
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        height: auto;
        padding-bottom: 4rem;
        margin: 1rem auto;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        width: 100%;
    }
`

const ArrowLink = styled(Link)`
    display: flex;
    flex: 0 0 auto;
    width: 100%;
    color: ${(props) => props.theme.colors.background} !important;
    border-bottom: 1px solid ${(props) => props.theme.colors.background};
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
    & .arrow,
    & .arrow:before,
    & .arrow:after {
        background-color: ${(props) =>
            props.theme.colors.background} !important;
    }
    &:hover {
        text-decoration: none !important;
        border-bottom: 3px solid ${(props) => props.theme.colors.background};
        transition: flex 0.3s linear;
        & .arrow {
            transition: all 0.3s linear;
            width: 100% !important;
            @media screen and (max-width: ${(props) =>
                    props.theme.breakpoints[3]}) {
                width: 3rem !important;
            }
        }
    }
    & .arrow-wrapper {
        flex: 0 0 20%;
    }
    &.join-our-team {
        margin-top: auto;
        margin-bottom: auto;
        justify-content: center;
    }
`

const Cards = ({ title, name, url, slug, imageFile }) => {
    const bgColor = [
        "#366E95",
        "#E08453",
        "#2B9A91",
        "#F8A947",
        "#E66772",
        "#8DC63F",
    ]
    const randomIdx = Math.floor(Math.random() * 6)
    let content = null
    if (name.toLowerCase() !== "join our team") {
        content = (
            <>
                <span className="team-content">{title}</span>
                <div className="image-wrapper">
                    <GatsbyImage image={getImage(imageFile)} alt={name} />
                </div>
            </>
        )
    }
    return (
        <TeamBox sx={{ backgroundColor: bgColor[randomIdx] }}>
            <ArrowLink to={`${url}/${slug}`} className={!content && "join-our-team"}>
                <span>{name}</span>
                <div className="arrow-wrapper">
                    <div class="arrow"></div>
                </div>
            </ArrowLink>
            {content}
        </TeamBox>
    )
}

export default Cards
